import { render, staticRenderFns } from "./registrationCertificate.vue?vue&type=template&id=0e29698d&scoped=true"
import script from "./registrationCertificate.vue?vue&type=script&lang=js"
export * from "./registrationCertificate.vue?vue&type=script&lang=js"
import style0 from "./registrationCertificate.vue?vue&type=style&index=0&id=0e29698d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e29698d",
  null
  
)

export default component.exports